export default "__VITE_ASSET__CfaBMzKB__"